const FALLBACK_TIMEZONE_IDS = [
  "UTC",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Kyiv",
  "Asia/Tokyo",
  "Asia/Shanghai",
  "Asia/Kolkata",
  "Australia/Sydney",
  "Pacific/Auckland"
] as const

declare const ianaTimezoneBrand: unique symbol

export type IanaTimezone = string & { readonly [ianaTimezoneBrand]: "IanaTimezone" }

export const isIanaTimezone = (value: string): value is IanaTimezone => {
  if (!value) return false

  try {
    new Intl.DateTimeFormat("en-GB", {
      timeZone: value,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).format(new Date())
    return true
  } catch (error: unknown) {
    if (!(error instanceof RangeError)) {
      console.error(`Unexpected error validating timezone "${value}":`, error)
    }
    return false
  }
}

export const toIanaTimezoneOrNull = (value: string | null | undefined): IanaTimezone | null => {
  if (!value) return null
  if (isIanaTimezone(value)) return value
  console.error(`Received invalid IANA timezone value "${value}"`)
  return null
}

export const getSupportedIanaTimezones = (): IanaTimezone[] => {
  const supportedIds = typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : []
  const ids =
    supportedIds.length > 0 ? [...new Set([...supportedIds, ...FALLBACK_TIMEZONE_IDS])] : [...FALLBACK_TIMEZONE_IDS]

  return ids.filter(isIanaTimezone)
}
